import { ChangeDetectionStrategy, Component, ElementRef, OnInit, computed, inject, input, output, signal } from "@angular/core";

import { Validator } from "@models";
import { TranslatePipe } from "@pipes";

import { ButtonComponent } from "../button/button.component";
import { CopyComponent } from "../copy/copy.component";

@Component({
  selector: "mn-text",
  styleUrls: ["./text.component.scss"],
  templateUrl: "./text.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, TranslatePipe, CopyComponent],
  host: { "(window:click)": "click($event)", "[class.focused]": "focus()" },
})
export class TextComponent implements OnInit {
  private readonly eR = inject(ElementRef);

  public value = input.required<string>();
  public validators = input<Validator[]>([]);
  public aEvent = input<string>("");
  public max = input<number>(0);

  public valueChange = output<string>();

  public saved = output<Event>();
  public focused = output<boolean>();

  protected readonly focus = signal<boolean>(false);
  protected readonly internal = signal<string>("");

  protected readonly invalid = computed<boolean>(() => {
    const internal = this.internal();

    return this.validators().some(validate => !validate(internal));
  });

  public ngOnInit(): void {
    this.internal.set(this.value());
  }

  public click(event: Event): void {
    this.focus.set(this.eR.nativeElement.contains(event.target));

    this.focused.emit(this.focus());
  }

  public input(event: Event): void {
    const val = (event.target as HTMLInputElement).value.trim();

    this.internal.set(val);
  }

  public save(event: Event): void {
    this.valueChange.emit(this.internal());
    this.saved.emit(event);
    this.focus.set(false);
  }
}
